import { QrCode } from 'lucide-react';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'qrcode',
  renderInput: ({ value, onChange }) => {
    const val = (value as string) ?? '';
    const qrUrl = val
      ? `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(val)}`
      : null;

    return (
      <div className="space-y-3">
        <textarea
          value={val}
          onChange={(e) => onChange(e.target.value || null)}
          rows={3}
          className="w-full resize-none rounded-md border border-border-primary bg-bg-primary px-3 py-1.5 text-sm text-text-primary placeholder:text-text-tertiary focus:border-accent-500 focus:ring-1 focus:ring-accent-500 focus:outline-none"
          placeholder="Wprowadź tekst do zakodowania (URL, tekst, dane kontaktowe…)"
          maxLength={500}
        />
        {qrUrl && (
          <div className="flex flex-col items-center gap-2 rounded-lg border-2 border-border-secondary bg-bg-primary p-4">
            <img src={qrUrl} alt="QR Code" className="h-40 w-40" />
            <span className="text-xs text-text-muted">{val.length} znaków</span>
          </div>
        )}
      </div>
    );
  },
  renderCell: (_field, value) => {
    if (!value) return '—';
    const short = String(value).slice(0, 30);
    return (
      <div className="flex items-center gap-2">
        <QrCode className="h-3.5 w-3.5 flex-shrink-0 text-text-muted" />
        <span className="text-xs text-text-primary">
          {short}
          {String(value).length > 30 ? '…' : ''}
        </span>
      </div>
    );
  },
  validate: (value, field) => {
    if (!value) return field.isRequired ? 'Pole wymagane' : null;
    if (String(value).length > 500) return 'Maksimum 500 znaków dla kodu QR';
    return null;
  },
  defaultValue: null,
});
